import React, { useRef, useState } from "react";
import clinicpic from "../assets/clinicpic.jpg";
import emailjs from "@emailjs/browser";

function ContactForm() {
  const formRef = useRef(null);
  const [status, setStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();  // <-- Correct spelling
    emailjs
      .sendForm(
        "service_wp56fzn",     // service ID
        "template_dslmd7q",   // template ID
        formRef.current,      // form reference
        "OTsun28Uoa1SZJS2e"   // public key (user ID)
      )
      .then((result) => {
        console.log("SUCCESS!", result.text);
        setStatus("Your message has been sent successfully!");
        // Optional: reset the form
        formRef.current.reset();
      })
      .catch((error) => {
        console.error("FAILED...", error);
        setStatus("Oh no! Something went wrong. Please try again.");
      });
  };

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-20">
        <h2 className="text-3xl md:text-4xl font-bold text-black text-center overflow-hidden">
          Partner with Us
        </h2>

        <div className="mt-10 flex flex-col lg:flex-row items-center gap-10">
          {/* Left Image Section */}
          <div className="flex-1 flex justify-center">
            <img
              src={clinicpic}
              alt="Diagnosure Logo"
              className="w-full shadow-lg"
            />
          </div>

          {/* Right Form Section */}
          <div className="flex-1">
            <form className="space-y-2" onSubmit={sendEmail} ref={formRef}>
              <input
                type="text"
                name="user_name"
                placeholder="Name"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <input
                type="email"
                name="user_email"
                placeholder="Email"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <input
                type="tel"
                placeholder="Phone"
                name="user_phone"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <input
                type="text"
                name="user_clinicname"
                placeholder="Clinic Name"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <input
                type="text"
                name="user_location"
                placeholder="Location"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <input
                type="text"
                name="user_specialty"
                placeholder="Specialty"
                className="w-full p-4 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange"
              />
              <button
                type="submit"
                className="bg-orange text-white font-semibold px-6 py-4 w-full rounded-lg hover:bg-orange-600 transition duration-300"
              >
                Submit
              </button>
            </form>
            {status && <p className="mt-2">{status}</p>}
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactForm;
